import type { App } from 'vue'

export const GlobalPlugin = {

    install(app: App, props: any) {

        for(let key of Object.keys(props)){
            app.config.globalProperties[key] = props[key];
        }
    }
}